module.exports = __webpack_public_path__ + "img/style_4_0.6c358a38.png";